import css from "../../css/listing/price-history.module.css";

import React from "react";
import PropTypes from "prop-types";
import { format, parseISO } from "date-fns";
import { hasFeature } from "../../service/listing";
import NoSSR from "../common/NoSSR";

import YesIcon from "mdi-react/CheckboxMultipleMarkedCircleIcon";

const OpenHouses = (props) => {
    const { listing } = props;

    if (!listing.listing_open_houses || !listing.listing_open_houses.length) {
        return <></>;
    }

    let i = 1;
    let openHouses = [];
    let withDate = true;

    for (let e of listing.listing_open_houses) {
        if (e.date) {
            // OLD FORMAT
            openHouses.push(
                <tr key={"open_house_" + i++}>
                    <td>
                        <NoSSR>
                            {format(parseISO(e.date), "MMM do, yyyy")}
                        </NoSSR>
                    </td>
                    <td>
                        <NoSSR>{e.start_time}</NoSSR>
                    </td>
                    <td>
                        <NoSSR>{e.end_time}</NoSSR>
                    </td>
                    <td className={css.yesIcon}>
                        {!!hasFeature(e.is_appointment_required) && (
                            <YesIcon alt="Yes" />
                        )}
                    </td>
                    <td>{e.description}</td>
                </tr>
            );
        } else {
            // NEW FORMAT
            withDate = false;

            openHouses.push(
                <tr key={"open_house_" + i++}>
                    <td className={css.datetime} suppressHydrationWarning>
                        <NoSSR>
                            {format(parseISO(e.start_time), "EEEE")}
                            <br />
                            {format(parseISO(e.start_time), "MMMM do, yyyy")}
                            <br />
                            <div className={css.time}>
                                {format(parseISO(e.start_time), "hh:mm aa")}
                            </div>
                        </NoSSR>
                    </td>
                    <td className={css.datetime} suppressHydrationWarning>
                        <NoSSR>
                            {format(parseISO(e.end_time), "EEEE")}
                            <br />
                            {format(parseISO(e.end_time), "MMMM do, yyyy")}
                            <br />
                            <div className={css.time}>
                                {format(parseISO(e.end_time), "hh:mm aa")}
                            </div>
                        </NoSSR>
                    </td>
                    <td className={css.yesIcon}>
                        {!!hasFeature(e.is_appointment_required) && (
                            <YesIcon alt="Yes" />
                        )}
                        {!!!hasFeature(e.is_appointment_required) && (
                            <span className={css.textNo}>No</span>
                        )}
                    </td>
                </tr>
            );
        }
    }

    return (
        <div className={css.priceHistory}>
            <table>
                <thead>
                    <tr>
                        {withDate && <th className={css.textCenter}>Date</th>}
                        <th className={css.textCenter} style={{ width: "33%" }}>
                            Start Time
                        </th>
                        <th className={css.textCenter} style={{ width: "33%" }}>
                            End Time
                        </th>
                        <th className={css.textCenter}  style={{ width: "33%" }}>
                            Appointment Required?
                        </th>
                    </tr>
                </thead>
                <tbody>{openHouses}</tbody>
            </table>
        </div>
    );
};

OpenHouses.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default OpenHouses;
